export const postCategoryData: Record<string, Record<string, Array<string>>> = {
    "Post publié" : {
        "Contenu professionnel": [
            "Succès & Parcours",
            "Partage d'expérience & Conseils",
            "Recommandations et témoignages",
            "Blagues et anecdotes"
        ],
        "Contenu personnel": [
            "Analyses et réflexions",
            "Tendances & Innovations"
        ],
        "Contenu sur la société ou produit": [
            "Promotion de produits ou services",
            "Stratégies & Branding",
            "Collaborations et partenariats"
        ],
        "Événements": [
            "Annonces d'Événements",
            "Retour d’expérience suite à un événement"
        ]
    },
    "Post republié" : {
        "Contenu professionnels" : [
            "Conseils professionnels",
            "Contenu inspirant"
        ],
        "Post d’entreprise" : [
            "Annonces officielles",
            "Succès Stories",
        ],
        "Événements partagés" : [
            "Événements à venir",
            "Événements passé"
        ]
    },
    "Post partagé" : {
        "Contenu professionnels" : [
            "Conseils professionnels",
            "Contenu inspirant"
        ],
        "Post d’entreprise" : [
            "Annonces officielles",
            "Succès Stories",
        ],
        "Événements partagés" : [
            "Événements à venir",
            "Événements passé"
        ]
    },
    "Description profil LinkedIn" : {
        "Profil personnel": [
            "Description LinkedIn",
            "Expériences professionnelles",
            "Compétences"
        ]
    },
    "Données de l'entreprise" : {
        "Données de l'entreprise": [
            "Description de l’entreprise",
            "Valeurs de l’entreprise",
            "Produits ou services vendus"
        ]
    }
}

export const categoriesList: Array<string> = Object.keys(postCategoryData)

export const CategoryDico: Record<string, Record<string, Array<string>>> = {
    [categoriesList[0]] : {
        "Catégorie": [
            "Sous-catégorie"
        ],
    },
}
